import { render, staticRenderFns } from "./DetectOCR.vue?vue&type=template&id=748545a2"
import script from "./DetectOCR.vue?vue&type=script&lang=js"
export * from "./DetectOCR.vue?vue&type=script&lang=js"
import style0 from "./DetectOCR.vue?vue&type=style&index=0&id=748545a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports